<template>
  <div class="text-center">
    <v-dialog v-model="alertSectors" persistent width="500">
      <v-card>
        <v-card-title> {{ $t("cart.removeReserved") }} </v-card-title>

        <v-card-text>
          {{ $t("cart.alertChangeSector") }}
        </v-card-text>

        <v-card-text> {{ $t("cart.doYouWishContinue") }} </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            outlined
            height="40"
            class="px-4"
            @click="$store.commit('SET_ALERT_SECTORS', false)"
          >
            {{ $t("cart.keepBuying") }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            depressed
            height="40"
            width="100"
            @click="reset"
          >
            {{ $t("cart.yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "alertSectors",
      "cartProducts",
      "listSeats",
      "chosenSector",
      "couponDetails",
      "eventId",
    ]),
  },
  methods: {
    reset() {
      this.cartProducts.forEach((product) => {
        product.forEach(async (el) => {
          let qtd = el.quantidade;
          for (var i = 0; i < qtd; i++) {
            await this.$store.dispatch("removeCartProduct", el);
          }
        });
      });
      this.$store.commit("SET_ALERT_SECTORS", false);
      this.$store.commit("SET_LIST_SEATS", null);

      let params = {
        event_id: this.eventId,
        sector_id: this.chosenSector.codigo,
      };
      if (this.couponDetails && this.couponDetails.isCupomValid)
        params.coupon = this.couponDetails.cupomData.campaign_coupon;

      this.$store.dispatch("getSeatsSector", params);

      this.$store.commit("SET_SELECTED_SECTOR", this.chosenSector);

      localStorage.setItem(
        `sector-selected-${this.eventId}`,
        JSON.stringify(this.chosenSector)
      );
      localStorage.setItem(`show-map-${this.eventId}`, "true");
      this.$store.commit("SET_SHOW_SEAT_MAP", true);
    },
  },
};
</script>
